import "./App.scss";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PiggyDodgePP from "./pages/games/PiggyDodgePP";
import PiggyDodgeTC from "./pages/games/PiggyDodgeTC";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="piggydodge-pp" element={<PiggyDodgePP />} />
        <Route path="piggydodge-tc" element={<PiggyDodgeTC />} />
      </Routes>
    </div>
  );
}

export default App;
